export const orders = {
  orders: "products/order/admin/",
  change_status: (id: number) => `products/order/admin/?id=${id}`,
  get_all_payments: "products/payment/admin/",
};
